import { spawn } from "redux-saga/effects";

import { addAudioFileReviewWatcherSaga } from "./audioFile/sagas/AddAudioFileReviewSaga";
import { getMetadataInfoWatcherSaga } from "./metadata/sagas/GetMetadataInfoSaga";
import { getAudioFileInfoWatcherSaga } from "./audioFile/sagas/GetAudioFileInfo";
import { getClientsWatcherSaga } from "./client/sagas/GetClientsSaga";
import { userLogoutWatcherSaga } from "./user/sagas/UserLogoutSaga";
import { refreshAuthTokenWatcherSaga } from "./user/sagas/RefreshTokenSaga";
import { userLoginWatcherSaga } from "./user/sagas/UserLoginSaga";

export default function* rootSaga() {
  yield spawn(userLoginWatcherSaga);
  yield spawn(userLogoutWatcherSaga);
  yield spawn(getClientsWatcherSaga);
  yield spawn(getMetadataInfoWatcherSaga);
  yield spawn(getAudioFileInfoWatcherSaga);
  yield spawn(addAudioFileReviewWatcherSaga);
  yield spawn(refreshAuthTokenWatcherSaga);
}
